import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

export function LegalProse({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        "space-y-6 text-sm font-medium leading-relaxed text-primary/70 [&_h2]:font-heading [&_h2]:mt-10 [&_h2]:text-lg [&_h2]:text-primary [&_h2]:first:mt-0 [&_p]:mt-3 [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pl-5 [&_strong]:text-primary",
        className,
      )}
    >
      {children}
    </div>
  )
}
